import { useIsDesktop } from '@/lib/useMediaQuery';
import { Modal, type DialogProps } from './Modal';
import { BottomSheet } from './BottomSheet';

/** Decide a superfície pelo viewport: Modal centralizado (desktop) ou BottomSheet (mobile). */
export function Sheet(props: DialogProps) {
  const isDesktop = useIsDesktop();
  return isDesktop ? <Modal {...props} /> : <BottomSheet {...props} />;
}
